import React from 'react';
import { Sidebar } from './Sidebar';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="flex h-screen bg-gray-50 overflow-hidden" data-id="element-142">
      <Sidebar data-id="element-143" />
      <main className="flex-1 overflow-y-auto" data-id="element-144">{children}</main>
    </div>;
}